/* eslint-disable */


/**
 * Create styles for `<NotificationsList />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<NotificationsList />` styles
 */
const notificationsListStyles = ({ theme }) => ({
  heading: {
    padding: `0 ${theme.spacing(1) * 2.3}px 0 ${theme.spacing(1) * 2.3}px`,
  },
  listItemRoot: {
    '&:last-child': {
      marginBottom: theme.spacing(1) * 4.5,
    },
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    padding: 0,
  },
  spinner: {
    animation: `1s spinnerAnimation`,
    color: theme.palette.grey[500],
    marginTop: -theme.spacing(1) * 6,
  },
});

export default notificationsListStyles;
